module.exports = __webpack_public_path__ + "img/arrow.ad5b19b5.svg";